import type { InvitationType } from '@/types';

/**
 * Human-readable labels for invitation/pass types. Shared across resident
 * surfaces so machine enum values (e.g. `single_visit`) never reach the UI.
 */
export const INVITATION_TYPE_LABEL: Record<InvitationType, string> = {
  single_visit: 'One-time',
  recurring: 'Recurring',
  domestic_worker: 'Domestic',
  delivery: 'Delivery',
  taxi: 'Taxi',
  event: 'Get-together',
  trusted_operator: 'Trusted Operator',
  walk_in: 'Walk-in',
  employee: 'Employee',
};

/** Safe lookup with a sensible fallback for unknown/missing types. */
export function invitationTypeLabel(type: InvitationType | string | null | undefined): string {
  if (!type) return 'Visitor';
  return INVITATION_TYPE_LABEL[type as InvitationType] ?? 'Visitor';
}

/** Human-readable labels for trusted-operator types. */
export const TRUSTED_OPERATOR_TYPE_LABEL: Record<string, string> = {
  school_bus: 'School Bus',
  shuttle: 'Shuttle',
  service_provider: 'Service Provider',
  other: 'Other',
};

/** Safe lookup for trusted-operator types with a humanised fallback. */
export function trustedOperatorTypeLabel(type: string | null | undefined): string {
  if (!type) return 'Operator';
  return (
    TRUSTED_OPERATOR_TYPE_LABEL[type] ??
    type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  );
}
